import React, { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import {
  LightModeOutlined,
  DarkModeOutlined,
  Menu as MenuIcon,
  Search,
  SettingsOutlined,
  ArrowDropDownOutlined,
} from "@mui/icons-material"
import FlexBetween from "components/FlexBetween"
import { useDispatch } from "react-redux"
import {
  AppBar,
  Button,
  Box,
  Typography,
  IconButton,
  InputBase,
  Toolbar,
  Menu,
  MenuItem,
  useTheme,
  createTheme
} from "@mui/material"
import utill from "lib/utill"
import store from "state/store"
import sessionSlice, { setSession } from "state/session"
import { setPublicKey } from "state/publickey"
import { setMode } from "state/mode"
import { themeSettings } from "theme"

const Navbar = ({ user, isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  const theme = createTheme(themeSettings("dark", "sidebar"))

  const [anchorEl, setAnchorEl] = useState(null)
  const isOpen = Boolean(anchorEl)
  const handleClick = (event) => setAnchorEl(event.currentTarget)

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

    // 단순히 메뉴를 닫는 로직
    const handleClose = () => {
      setAnchorEl(null);
    };

      // 로그아웃 처리 로직
  const handleLogout = () => {
    handleClose(); // 메뉴 닫기
    navigate("/login");
    dispatch(setSession(""));
    dispatch(setPublicKey(""));
    sessionStorage.clear();
  };

  return (
    <AppBar
      sx={{
        position: "static",
        backgroundColor: theme.palette.grey[900],
        boxShadow: "none",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* left side */}
        <FlexBetween>
          {/* <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <MenuIcon />
          </IconButton> */}
          {/* <FlexBetween
            backgroundColor={theme.palette.background.alt}
            borderRadius="9px"
            gap="3rem"
            p="0.1rem 1.5rem"
          >
            <InputBase placeholder="Search..." />
            <IconButton>
              <Search />
            </IconButton>
          </FlexBetween> */}
        </FlexBetween>

        {/* right side */}
        <FlexBetween gap="1.5rem">
          {/* <IconButton
            onClick={() => store.dispatch(setMode(theme.palette.mode))}
          >
            {theme.palette.mode === "dark" ? (
              <DarkModeOutlined sx={{ fontSize: "25px" }} />
            ) : (
              <LightModeOutlined sx={{ fontSize: "25px" }} />
            )}
          </IconButton> */}
          {/* <IconButton>
            <SettingsOutlined sx={{ fontSize: "25px" }} />
          </IconButton> */}
          <FlexBetween>
            <Button
              onClick={handleClick}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textTransform: "none",
                gap: "1rem",
              }}
              >
              <Box textAlign="left">
                <Typography
                  fontWeight="bold"
                  fontSize="1rem"
                  sx={{ color: theme.palette.secondary.main }}
                >
                  {utill.base64Decode(sessionStorage.getItem("x-a-h-t") ?? "")}
                </Typography>
              </Box>
              <Box textAlign="left">
                <Typography
                  fontWeight="bold"
                  fontSize="0.85rem"
                  sx={{ color: theme.palette.secondary.main }}
                >
                  {utill.base64Decode(sessionStorage.getItem("x-a-d-n") ?? "")}
                </Typography>
              </Box>
              <ArrowDropDownOutlined
                sx={{ color: theme.palette.secondary.main, fontSize: "25px" }}
              />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={isOpen}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <MenuItem onClick={handleLogout}>로그아웃</MenuItem>
            </Menu>
          </FlexBetween>
        </FlexBetween>
      </Toolbar>
    </AppBar>
  )
}

export default Navbar
